var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-overlay',{attrs:{"id":"overlay-background","variant":"dark","show":_setup.props.active,"opacity":0.6,"rounded":_setup.props.rounded},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('i',{staticClass:"fas fa-spinner fa-spin"})]},proxy:true}])},[_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }